import styled, { ThemeProvider } from 'styled-components';
import type { IStockStatusViewModelMaybe, ProductStoreStockViewModel } from 'autogen/swagger/all';
import ProductStockInfoRenderer from './components/ProductStock';
import StoreStockInfoRenderer from './components/StoreStock';
import useThemeHandler from './themes/useThemeHandler';

export type StockInfoProps = {
    productId: number;
    storeStock?: ProductStoreStockViewModel;
    productStock?: IStockStatusViewModelMaybe;
};

const Container = styled.div`
    border: 1px solid ${({ theme }) => theme.ColorBorderSecondary};
    border-radius: ${({ theme }) => theme.RadiusMedium};

    ${({ theme }) => (theme as any).StockInfoContainer}
`;

export default function StockInfo(props: StockInfoProps) {
    const { storeStock, productStock, productId } = props;
    const theme = useThemeHandler();

    return (
        <ThemeProvider theme={theme}>
            <Container>
                {productStock && <ProductStockInfoRenderer model={productStock} productId={productId} />}
                {storeStock && <StoreStockInfoRenderer model={storeStock} productId={productId} />}
            </Container>
        </ThemeProvider>
    );
}
